import { ReactElement } from 'react';
import classnames from 'classnames';
import DiscountsIcon from '../../modules/mobile/assets/icons/DiscountsIcon';
interface Props {
  title: string | JSX.Element;
  description: string | ReactElement;
  footer?: ReactElement;
  className?: string;
  onClick?: () => void;
}

export default function DiscountCard(props: Props): ReactElement {
  const { title, description, footer, className, onClick } = props;

  return (
    <div
      className={classnames('h-full flex justify-between rounded-xl border overflow-hidden', className)}
      onClick={onClick}
    >
      <div className="size-full px-md flex flex-col justify-between p-sm space-y-md">
        <div>
          <h6 className="font-semibold">{title}</h6>
          <p className="text-xs text-gray-700 mt-[2px]">{description}</p>
        </div>
        {footer}
      </div>
      <div className="bg-primary px-md flex h-full justify-center items-center">
        <DiscountsIcon className="h-[32px] w-[32px]" color="white" />
      </div>
    </div>
  );
}
